import signupConfig from "../../config/signup/signupConfig";
import { apiService } from "../apiService";
import urlConfig from "../../config/domain";

export const signFormSubmit = (callback, body) => {
  apiService(
    {
      url: signupConfig.taskLead,
      method: "POST",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const vendorSignFormSubmit = (callback, body, headers) => {
  apiService(
    {
      url: signupConfig.vendor_signup,
      method: "POST",
      authType: "encryption",
      headers: headers,
      appidkey: urlConfig.appidkey,
      appid: urlConfig.appId,
      body,
    },
    callback
  );
};

export const vendorReqACall = (callback, body) => {
  apiService(
    {
      url: signupConfig.vendor_req_a_call,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      appid: urlConfig.appId,
      body,
    },
    callback
  );
};
